import TitleDashboard from "@components/general/Titles/TitleDashboard";
import DetalleRenovacion from "@components/usuario/RenovacionLicencia/DetalleRenovacion";
import UserContext from "@context/User/UserContext";
import numberCommaSeparator from "@helpers/formateoPrecios/numberCommaSeparator";
import { getOrdenKueskiByFolio } from "@helpers/httpRequests/httpRequestKueski/httpRequesKueski";
import { enviarComprobanteRenovacion } from "@helpers/httpRequests/httpRequestsMailers/httpRequestsMailers";
import { retrievePaymentIntent } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import { getDatosUsuario, renovarLicencia } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";
import { Alert, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { NotificationManager } from "react-notifications";

const enviarComprobante = (datosComprobante, formValues, datosCompra, paymentMethod, paymentIntent) => {
		return new Promise(async (resolve, reject) => {
			try {

				const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;

				const { metodoPago, precios } = datosCompra;

				const {
					card: { last4 },
				} = paymentMethod;

				const {
					id: paymentIntentId,
					// amount: montoCobro,
					payment_method_options: { card },
				} = paymentIntent;

				const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;

				const replacements = {
					folioContrato,
					titular,
					numeroTarjeta: `Tarjeta con terminación ${last4}`,
					metodoPago: "De contado",
					description: `Renovación de Licencia Click+ Premium - Folio ${folioContrato}`,
					paymentIntentId,
					correo,
					montoCobro: numberCommaSeparator(datosComprobante.montoCobro / 100),
					costoBase:numberCommaSeparator(datosComprobante.montoCobro / 100),
					
				};

				await enviarComprobanteRenovacion(replacements);

				resolve();
			} catch (error) {
				console.log("Error al enviar el comprobante de compra: ", error);

				reject(error);
			}
		});
	};

const enviarComprobanteKueski = (datosComprobante, formValues, datosCompra, paymentIntent) => {
	return new Promise(async (resolve, reject) => {
		try {

			const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;

			const { metodoPago, precios } = datosCompra;


			const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;

			const replacements = {
				folioContrato,
				titular,
				numeroTarjeta: `-`,
				metodoPago: "De contado",
				description: `Renovación de Licencia Click+ Premium - Folio ${folioContrato}`,
				paymentIntentId: paymentIntent.paymentIntent,
				correo,
				montoCobro: numberCommaSeparator(datosComprobante.montoCobro),
				costoBase: numberCommaSeparator(precios.contado.monto)
					
			};

			await enviarComprobanteRenovacion(replacements);

			resolve();
		} catch (error) {
			console.log("Error al enviar el comprobante de compra: ", error);

			reject(error);
		}
	});
};


const RenovacionLicencia = () => {
	const { contextValue, setContextValue } = useContext(UserContext);

	const { renovacion, usuarioLogeado } = contextValue;

	let { folioContrato, rol, idPersona, idCredencial, licenciaRenovacion, folioRenovacion, idCodigoRegion } = usuarioLogeado;

	if (rol === typesTiposUsuario.administrador) {
		folioContrato = "753";
	}


	const [licenciaRenovada, setLicenciaRenovada] = useState(false);

	const getCostoTotal = () => {
		try {
			const { precios } = renovacion;

			let costoTotal = 0;

			switch (renovacion.metodoPago) {
				case "contado":
				case "msi":
					costoTotal = precios[renovacion.metodoPago].monto;

					break;

				case "credito":
					costoTotal = precios.credito.precioTotal;
					break;

				default:
					console.log("metodo de pago desconocido", renovacion.metodoPago);
					break;
			}

			return costoTotal;
		} catch (error) {
			console.log("error al obtener el costo total: ", error);
		}
	};

	const getAmortizacionesTotales = () => {
		try {
			let amortizacionesTotales = 0;

			if (renovacion.metodoPago === "contado" || renovacion.metodoPago === "msi") {
				amortizacionesTotales = 1;
			} else {
				const { precios } = renovacion;

				amortizacionesTotales = precios.credito.totalPagosQuincenales;
			}

			return amortizacionesTotales;
		} catch (error) {
			console.log("error al obtener las amortizaciones totales: ", error);
		}
	};

	const getMontoQuincenal = () => {
		try {
			let montoQuincenal = null;

			if (renovacion.metodoPago !== "contado") {
				const { precios } = renovacion;

				montoQuincenal = precios.credito.pagoQuincenal;
			}

			return montoQuincenal;
		} catch (error) {
			console.log("error al obtener el monto quincenal: ", error);
		}
	};

	const procesarRenovacionKueski = async() =>{
		try {
			//*Se recuperan los datos de la compra de la tabla ordenes_kueski a partir del folio de contrato.
			//*Se llenan los datos de la renovacion y se envian al backend para registrarse.
			//*Se actualizan los datos del usuario.
			//*Se actualiza el contextValue con los datos correspondientes y se envia el comprobante.

			const {data} = await getOrdenKueskiByFolio(folioContrato);
			console.log(data);

			const datosRenovacion = {
				folioContrato,
				pagoDeContado: renovacion.metodoPago === "contado",
				costoTotal: getCostoTotal(),
				amortizacionesTotales: getAmortizacionesTotales(),
				montoPagado: data.monto,
				montoQuincenal: getMontoQuincenal(),
				metodoPago: renovacion.metodoPago,
				tipoTarjeta: "credit",
				referenciaPago: data.payment_id,
			};

			await renovarLicencia({
				folioContrato: usuarioLogeado.folioContrato,
				datosRenovacion,
				idPersona,
				idCredencial,
				idRegion: idCodigoRegion,
				folioRenovacion
			});

			const { data: datosUsuario } = await getDatosUsuario({
				tipoUsuario: usuarioLogeado.rol,
				idCredencial: usuarioLogeado.idCredencial,
				usuarioTitular: usuarioLogeado.usuarioTitular,
			});

			const [datosUsuarioActualizados] = datosUsuario;

			setContextValue({
				...contextValue,
				usuarioLogeado: datosUsuarioActualizados,
				renovacion: undefined,
			});

			await enviarComprobanteKueski(
				{
					titular: `${usuarioLogeado.nombreCompleto} ${usuarioLogeado.apellidos}`,
					paymentIntentId: data.payment_id,
					folioContrato,
					montoCobro: data.monto,
					numeroTarjeta: `Compra por Kueski Pay`,
					description: `Renovación de Licencia Click+ - Folio ${folioContrato}`,
					correo: usuarioLogeado.correo,
				},
				{ 
					folioContrato, 
					nombre: usuarioLogeado.nombreCompleto, 
					apellidoPaterno: usuarioLogeado.apellidos.split(" ")[0], 
					apellidoMaterno: usuarioLogeado.apellidos.split(" ")[0], 
					correo: usuarioLogeado.correo 
				},
				{ metodoPago: renovacion.metodoPago, precios: renovacion.precios },
				{paymentIntent: data.payment_id}
			);

			NotificationManager.success("¡Renovación efectuada con éxito!");
			
		} catch (error) {
			console.log("Error al renovar la licencia con pago Kueski", error);
		}
	}

	// const procesarRenovacion = async () => {
	// 	try {
	// 		const { stripeSession } = renovacion;

	// 		const { amount_total, payment_intent: paymentIntentId } = stripeSession;

	// 		const { paymentIntent, paymentMethod } = await retrievePaymentIntent(paymentIntentId);

	// 		const { id: folioPago, amount } = paymentIntent;

	// 		const {
	// 			card: { last4, funding },
	// 		} = paymentMethod;

	// 		const datosRenovacion = {
	// 			folioContrato,
	// 			pagoDeContado: renovacion.metodoPago === "contado",
	// 			costoTotal: getCostoTotal(),
	// 			amortizacionesTotales: getAmortizacionesTotales(),
	// 			montoPagado: amount / 100,
	// 			montoQuincenal: getMontoQuincenal(),
	// 			metodoPago: renovacion.metodoPago,
	// 			tipoTarjeta: funding,
	// 			referenciaPago: paymentIntentId,
	// 		};

	// 		await renovarLicencia({
	// 			folioContrato: usuarioLogeado.folioContrato,
	// 			datosRenovacion,
	// 			idPersona,
	// 			idCredencial,
	// 			idRegion: idCodigoRegion,
	// 			folioRenovacion
	// 		});

	// 		const { data: datosUsuario } = await getDatosUsuario({
	// 			tipoUsuario: usuarioLogeado.rol,
	// 			idCredencial: usuarioLogeado.idCredencial,
	// 			usuarioTitular: usuarioLogeado.usuarioTitular,
	// 		});

	// 		const [datosUsuarioActualizados] = datosUsuario;

	// 		setContextValue({
	// 			...contextValue,
	// 			usuarioLogeado: datosUsuarioActualizados,
	// 			renovacion: undefined,
	// 		});

	// 		await enviarComprobante(
	// 			{
	// 				titular: `${usuarioLogeado.nombreCompleto} ${usuarioLogeado.apellidos}`,
	// 				paymentIntentId: folioPago,
	// 				folioContrato,
	// 				montoCobro: amount,
	// 				numeroTarjeta: `Tarjeta con terminación ${last4}`,
	// 				description: `Renovación de Licencia Click+ - Folio ${folioContrato}`,
	// 				correo: usuarioLogeado.correo,
	// 			},
	// 			{ 
	// 				folioContrato, 
	// 				nombre: usuarioLogeado.nombreCompleto, 
	// 				apellidoPaterno: usuarioLogeado.apellidos.split(" ")[0], 
	// 				apellidoMaterno: usuarioLogeado.apellidos.split(" ")[0], 
	// 				correo: usuarioLogeado.correo 
	// 			},
	// 			{ metodoPago: renovacion.metodoPago, precios: renovacion.precios },
	// 			paymentMethod,
	// 			paymentIntent
	// 		);

	// 		NotificationManager.success("¡Renovación efectuada con éxito!");

	// 		// setTimeout(() => window.location.reload(), 1500);
	// 	} catch (error) {
	// 		console.log("Error al renovar la licencia: ", error);
	// 	}
	// };

	const procesarRenovacion = async () => {
			try {
				const { stripeSession } = renovacion;
	
				const { amount_total, payment_intent: paymentIntentId, metadata } = stripeSession;
	
				const { paymentIntent, paymentMethod } = await retrievePaymentIntent(paymentIntentId);
	
				const { id: folioPago, amount } = paymentIntent;
	
				const {
					card: { last4, funding },
				} = paymentMethod;
	
				const datosRenovacion = {
					folioContrato: usuarioLogeado.folioContrato,
					pagoDeContado: true,
					costoTotal: amount / 100,
					amortizacionesTotales: 1,
					montoPagado: amount / 100,
					montoQuincenal: amount / 100,
					metodoPago: 'contado',
					tipoTarjeta: funding,
					referenciaPago: paymentIntentId,
				};
				//*En el componente de mis pagos no se consultan correctamente las amortizaciones, lo que causa problemas al renovar la licencia.
				await renovarLicencia({
					folioContrato: metadata.folioContrato,
					datosRenovacion,
					idPersona,
					idCredencial: usuarioLogeado.idCredencial,
					idRegion: usuarioLogeado.idCodigoRegion,
					folioRenovacion: usuarioLogeado.folioRenovacion
				});
	
				const { data: datosUsuario } = await getDatosUsuario({
					tipoUsuario: usuarioLogeado.rol,
					idCredencial: usuarioLogeado.idCredencial,
					usuarioTitular: usuarioLogeado.usuarioTitular,
				});
	
				const [datosUsuarioActualizados] = datosUsuario;
	
				setContextValue({
					...contextValue,
					usuarioLogeado: datosUsuarioActualizados,
					renovacion: undefined,
				});
	
				console.log("Enviando comprobante de renovacion");
	
				await enviarComprobante(
					{
						titular: `${usuarioLogeado.nombreCompleto} ${usuarioLogeado.apellidos}`,
						paymentIntentId: folioPago,
						folioContrato,
						montoCobro: amount,
						numeroTarjeta: `Tarjeta con terminación ${last4}`,
						description: `Renovación de Licencia Click+ - Folio ${folioContrato}`,
						correo: usuarioLogeado.correo,
					},
					{
						folioContrato,
						nombre: usuarioLogeado.nombreCompleto,
						apellidoPaterno: usuarioLogeado.apellidos.split(" ")[0],
						apellidoMaterno: usuarioLogeado.apellidos.split(" ")[0],
						correo: usuarioLogeado.correo
					},
					{ metodoPago: renovacion.metodoPago, precios: renovacion.precios },
					paymentMethod,
					paymentIntent
				);
	
				NotificationManager.success("¡Renovación efectuada con éxito!");
	
				// setTimeout(() => window.location.reload(), 1500);
			} catch (error) {
				console.log("Error al renovar la licencia: ", error);
			}
		};

	useEffect(() => {

		if (renovacion) {
			if (renovacion.pagoFinalizado && renovacion.renovacionKueski === false) {
				procesarRenovacion();
			}

			if (renovacion.pagoFinalizado && renovacion.renovacionKueski === true) {
				procesarRenovacionKueski();
			}
		}

		if (parseInt(folioRenovacion) > 0) {
			setLicenciaRenovada(true);
		}
	}, []);

	return (
		<Container fluid className="py-3">
			{licenciaRenovada && licenciaRenovacion ? (
				<Card body className="mb-3">
					<TitleDashboard title="Tu licencia se encuentra en un plan de renovación, sigue disfrutando de todo el contenido y actualizaciones futuras a nuestros cursos y herramientas de la plataforma" />

					<br />
{/* 
					<Typography variant="body1" gutterBottom>
						Renovaciones efectuadas: {folioRenovacion}
					</Typography>

					<br /> */}

					<Typography gutterBottom variant="caption">
						<span className="text-danger">*</span> Dejarás de tener acceso a tu cuenta y perderás todos los beneficios una vez canceles tu suscripción.
					</Typography>

					<br />
					
				</Card>
			) : null}

			<TitleDashboard title="Renovar Licencia" />

			<DetalleRenovacion usuarioLogeado={usuarioLogeado} />
		</Container>
	);
};

export default RenovacionLicencia;
